import { Grid } from "@material-ui/core"
import { graphql, useStaticQuery } from "gatsby"
import React from "react"
import HeadingBar from "./HeadingBar"
import ImageCard from "../Shared/ImageCard"

export default function TeamsSection() {
  const data = useStaticQuery(query)

  return (
    <>
      <HeadingBar text="Teams" />
      {data.allSanityTeam.nodes.map(team => (
        <Grid key={team.id} item xs={12} sm={6} md={4}>
          <ImageCard
            title={team.name}
            img={team.image}
            linkTo={`/teams/${team.slug.current}`}
          />
        </Grid>
      ))}
    </>
  )
}

const query = graphql`
  query {
    allSanityTeam {
      nodes {
        id
        name
        slug {
          current
        }
        image {
          ...ImageWithPreview
        }
      }
    }
  }
`
